import { styled } from '@mui/material/styles';
import { useDrawingArea } from '@mui/x-charts/hooks';
import type { ReactNode } from 'react';

const StyledPieChartCenterLabel = styled('text')(({ theme }) => ({
  dominantBaseline: 'central',
  fill: theme.palette.text.secondary,
  fontSize: 24,
  fontWeight: 500,
  letterSpacing: 0.15,
  lineHeight: 32,
  textAnchor: 'middle',
}));

type PieChartCenterLabelProps = {
  children: ReactNode;
};

export function PieChartCenterLabel(props: PieChartCenterLabelProps) {
  const { children } = props;
  const { height, left, top, width } = useDrawingArea();

  return (
    <StyledPieChartCenterLabel x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledPieChartCenterLabel>
  );
}
